import router from '@/router/rectifyRouter.js';
import store from '@/store';
// import Vue from "vue";
import App from "./App.vue";

import '@/styles/base.less';
import "@/styles/reset.less";

// import '@/plugins/vant';
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#rectify");

